module.exports = __webpack_public_path__ + "img/sipky-6.ca59377e.png";